import React from 'react'
import { PRICING_TABLE_PLUS } from '@chegg-wt/core/constants/pricingTable'
import usePriceTest from '@chegg-wt/core/hooks/usePriceTest'
import { PricingTable as PricingTableType } from '@chegg-wt/core/types/core'
import { useSelector } from 'react-redux'
import { isProSelector } from '@chegg-wt/core/state/user/selectors'
import PricingTable from '../PricingTable'

interface Props {
  currentProductId?: string
  pricingTableData: PricingTableType
}

export const HomePricingTable: React.FC<Props> = ({
  currentProductId,
  pricingTableData,
}) => {
  const {
    freeTrial,
    price,
    pricingExperimentEnabled,
    basePrice,
    discountPercentage,
  } = usePriceTest()

  const isProUser = useSelector(isProSelector)

  if (!pricingExperimentEnabled) {
    return (
      <PricingTable tableData={pricingTableData} currentProductId={currentProductId} />
    )
  }
  const expPricingTableData = {
    ...pricingTableData,
    // Update table plus column with experiment data
    products: pricingTableData.products.map((product) =>
      product.id === PRICING_TABLE_PLUS
        ? {
            ...product,
            name: freeTrial
              ? product.name
              : product.name.replace(' 3-day free trial*', ''),
            price: `${price}/mo.`,
            basePrice: `${basePrice}/mo.`,
          }
        : { ...product }
    ),
  }

  return (
    <PricingTable
      tableData={expPricingTableData}
      currentProductId={currentProductId}
      discountPercentage={isProUser ? null : discountPercentage}
    />
  )
}

export default HomePricingTable
